import { NgModule } from '@angular/core';
import { SharedModule, addNavMenuItem } from '@vendure/admin-ui/core';

@NgModule({
    imports: [SharedModule],
    providers: [
        addNavMenuItem({
            id: 'credit-accounts',
            label: 'Cuentas de Crédito',
            routerLink: ['/extensions/credit/list'],
            icon: 'list',
        }, 'sales'),
        addNavMenuItem({
            id: 'credit-approvals',
            label: 'Aprobar Abonos',
            routerLink: ['/extensions/credit/approvals'],
            icon: 'bank',
        }, 'sales'),
    ],
})
export class CreditSharedModule {}
